import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl } from 'react-intl';
import { compose } from 'redux';

import moment from 'moment';
import Loader from '../Loader/Loader';
import { withRtl } from '../hoc';
import style from './SchoolEvents.scss';
import { getSchoolEvents } from '../../actions/schools';
import CheckIcon from '../icons/Check';
import analytics from '../../services/analytics';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  accordionSchoolEvents: {
    id: 'schoolinfo.accordionSchoolEvents',
    defaultMessage: 'Upcoming Events',
    description: 'Accordion label for school events',
  },
  accordionSchoolEventsAt: {
    id: 'schoolinfo.accordionSchoolEventsAt',
    defaultMessage: 'at',
    description: 'Accordion label for school events before time',
  },
  accordionSchoolEventsMore: {
    id: 'schoolinfo.accordionSchoolEventsMore',
    defaultMessage: 'View All',
    description: 'Accordion label for more link',
  }
});

class SchoolEvents extends PureComponent {
  static defaultProps = {
    schoolEvents: [],
  };
  static propTypes = {
    intl: PropTypes.shape().isRequired,
    schoolEvents: PropTypes.arrayOf(PropTypes.shape({})),
    bapurl: PropTypes.string
  };

  pageDirectory = 'directory';
  pageApply = 'apply';
  pageWaitlist = 'waitlist';

  pageOptions = {
    'directory': 'School Directory',
    'apply': 'Application Apply',
    'waitlist': 'Application Waitlist'
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      schoolEvents: [],
      more: false,
      rsvps_ids: []
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    let start = moment().format();
    let end = moment().add({year: 2}).format();

    dispatch(getSchoolEvents(this.props.dbn, start, end)).catch(error => {
      this.setState({
        ...this.state,
        loading: false,
        more: false
      });
    }).then(data => {
      data.events.map((item) => {
        let itemDate = moment(item.event_start).format('MM/DD/YYYY');
        let itemStart = moment(item.event_start).format('hh:mm');
        let itemEnd = moment(item.event_end).format('hh:mm');
        moment.locale(this.props.intl.locale);
        let itemStartMeridiem = moment(item.event_start).format('A');
        let itemEndMeridiem = moment(item.event_end).format('A');
        moment.locale('en');
        item['localeTime'] = itemDate + ' ' + itemStart + itemStartMeridiem + ' - ' + itemEnd + itemEndMeridiem;
      });

      this.setState({
        ...this.state,
        schoolEvents: data.events,
        more: data.more,
        loading: false,
        rsvps_ids: data.rsvps_ids ? data.rsvps_ids : []
      });
    });
  }

  performGAEvent = (url, isViewAll) => {
    let source = this.pageOptions[this.props.page];
    let eventOption = isViewAll ? 'View All' : 'View Event';
    analytics({
      eventLabel: 'schoolEventClick',
      dataDictionary: {
        eventUrl: url,
        eventSource: `${this.props.dbn} - ${source} - ${eventOption}`,
        loggedIn: window.App.state.user.guardianId != '' ? true : false
      },
    });
  }

  openMoreEvent = () => {
    const { intl } = this.props;
    let url = `/${intl.locale}/calendar/?school=${this.props.dbn}`;
    this.performGAEvent(url, true);
    window.open(url, '_blank');
  }

  openEvent = (url) => {
    this.performGAEvent(url, false);
    window.open(url, '_blank');
  }

  getschoolEvents = () => {
    const schoolEventsList = this.state.schoolEvents.map((item, index) => 
    (<li key={item.title + index}>
      <p className={style.rsvpIcon}>
        <button type="button" onClick={() => this.openEvent(item.url)}><b>{item.title}</b></button>
        {
          this.state.rsvps_ids.indexOf(item.occurrence_id) > -1 &&
          <CheckIcon
            //
            fill="rgb(78, 228, 179)"
            size={18}
          />
        }
      </p>
      <p>
        <span className={this.props.isRtl ? style.eventTimeRight + " icon-Time icon-fill" : " icon-Time icon-fill"}></span>&nbsp;
        {item.localeTime}
      </p>
      <hr />
    </li>
    ));
    return <ul className={style.schoolEvents}>
      {schoolEventsList}
    </ul>;
  };

  renderDirectoryPage = () => {
    const { intl } = this.props;
    return (
      <div className={style.overview}>
        <h3 className={style.sectionTitle}>
          {customisedIntlFormatMessage(intl, localMessages.accordionSchoolEvents)}
          {
            this.state.more != 0 && 
            <button type="button" onClick={() => this.openMoreEvent()} style={{float: 'right', fontSize: '14px'}} >
              {customisedIntlFormatMessage(intl, localMessages.accordionSchoolEventsMore)}
            </button>
          }
        </h3>
        {this.getschoolEvents()}
      </div>
    );
  }

  renderApplyPage = () => {
    return this.renderWaitlistPage();
  }

  renderWaitlistPage = () => {
    const { intl } = this.props;
    return <>
      <hr />
      <div className={style.schoolEventHeading}>
        <b> <i className="icon-calendar-outline"></i> {customisedIntlFormatMessage(intl, localMessages.accordionSchoolEvents)}</b>
        {
          this.state.more == 1 &&
          <button type="button" className={style.viewMore} onClick={() => this.openMoreEvent()}>
            {customisedIntlFormatMessage(intl, localMessages.accordionSchoolEventsMore)}
          </button>
        }
      </div>
      <ul className={style.schoolEvents}>
        {
          this.state.schoolEvents.map((item) => {
            return <li key={'event-' + item.id + item.occurrence_id}>
              <p className={style.rsvpIcon}>
                <button type="button" onClick={() => this.openEvent(item.url)} ><b>{item.title}</b></button>
                {
                this.state.rsvps_ids.indexOf(item.occurrence_id) > -1 &&
                <CheckIcon
                  //
                  fill="rgb(78, 228, 179)"
                  size={18}
                />
                }
              </p>
                <p><span className={this.props.isRtl ? style.eventTimeRight + " icon-Time icon-fill" : " icon-Time icon-fill"}></span>&nbsp;
                {item.localeTime}
                </p>
              <hr />
            </li>
          })
        }    
      </ul>
    </>
  }

  /* eslint-disable react/no-danger */
  render() {
    if(this.state.loading){
      return <Loader aria-label="loader" />
    }else if(!this.state.loading && this.state.schoolEvents.length == 0){
      return null;
    }else{
      if(this.props.page == this.pageDirectory){
        return this.renderDirectoryPage();
      } else if (this.props.page == this.pageApply) {
        return this.renderApplyPage();
      } else if(this.props.page == this.pageWaitlist) {
        return this.renderWaitlistPage();
      } else {
        return null;
      }
    }
  }
}

export { SchoolEvents };
export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
)(SchoolEvents);
